import { Component, forwardRef, HostListener, Input } from '@angular/core';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlClass } from '../base-control/base-control';

@Component({
    selector: 'pace-authors-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropdownComponent),
            multi: true,
        },
    ],
})
export class DropdownComponent extends BaseControlClass {
    @Input({ required: true }) public label = '';
    @Input() public options: string[] = [];

    public faCaretDown = faCaretDown;
    public showDropDown = false;
    public displayValue = '';
    public filteredOptions: string[] = [];

    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: MouseEvent): void {
        if (!(event.target as Element).closest('.dynamic-dropdown')) {
            this.showDropDown = false;
            this.validateSelectedOption();
        }
    }

    public onSelectChange(value: string): void {
        this.showDropDown = false;
        this.displayValue = value;
        this.notifyValueChange(value);
    }

    public openDropDown(): void {
        this.showDropDown = true;
        this.filterOptions();
    }

    public onInput(): void {
        this.filterOptions();
    }

    private filterOptions(): void {
        this.filteredOptions = this.options.filter((option) =>
            option.toLowerCase().includes(this.displayValue.toLowerCase()),
        );
    }

    private validateSelectedOption(): void {
        const hasValidOption = this.options.some((option) => option === this.displayValue);

        if (!hasValidOption) {
            this.onClear();
        }
    }

    public onCaretClick(): void {
        this.showDropDown = !this.showDropDown;
        this.filterOptions();
    }

    private onClear(): void {
        this.displayValue = '';
        this.showDropDown = false;
        this.notifyValueChange('');
    }
}
